import { useCallback, useEffect, useRef, useState } from "react";

const FLASH_DURATION_MS = 450;

export const useEditButtonFlash = (): { flashClassName: string; flash: () => void } => {
  const [flashing, setFlashing] = useState(false);
  const frameRef = useRef<number | null>(null);
  const timerRef = useRef<number | null>(null);

  const clear = () => {
    if (frameRef.current !== null) {
      cancelAnimationFrame(frameRef.current);
      frameRef.current = null;
    }
    if (timerRef.current !== null) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const flash = useCallback(() => {
    clear();
    setFlashing(false);
    frameRef.current = requestAnimationFrame(() => {
      setFlashing(true);
      timerRef.current = window.setTimeout(() => setFlashing(false), FLASH_DURATION_MS);
    });
  }, []);

  useEffect(() => clear, []);

  return { flashClassName: `-mx-2 px-2 ${flashing ? "slopify-flash" : ""}`, flash };
};
